// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.uDUse8xCMXiRMl_qIXJs {
    width: 100%;
    box-sizing: border-box;
}
.nNON9WAt9MPYJGWC1qvQ {
    display: grid;
    grid-template-columns: minmax(24rem, 36rem) minmax(0, 1fr);
    gap: 2.4rem;
    align-items: end;
}
@media (max-width: 700px) {
    .nNON9WAt9MPYJGWC1qvQ {
        grid-template-columns: minmax(0, 1fr);
    }
}
`, "",{"version":3,"sources":["webpack://./pages/Mark/pages/Blasts/template.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,sBAAsB;AAC1B;AACA;IACI,aAAa;IACb,0DAA0D;IAC1D,WAAW;IACX,gBAAgB;AACpB;AACA;IACI;QACI,qCAAqC;IACzC;AACJ","sourcesContent":[".page {\n    width: 100%;\n    box-sizing: border-box;\n}\n.variantBar {\n    display: grid;\n    grid-template-columns: minmax(24rem, 36rem) minmax(0, 1fr);\n    gap: 2.4rem;\n    align-items: end;\n}\n@media (max-width: 700px) {\n    .variantBar {\n        grid-template-columns: minmax(0, 1fr);\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export var page = `uDUse8xCMXiRMl_qIXJs`;
export var variantBar = `nNON9WAt9MPYJGWC1qvQ`;
export default ___CSS_LOADER_EXPORT___;
